import { render, staticRenderFns } from "./add-pass.vue?vue&type=template&id=12482166"
import script from "./add-pass.vue?vue&type=script&lang=js"
export * from "./add-pass.vue?vue&type=script&lang=js"
import style0 from "./add-pass.vue?vue&type=style&index=0&id=12482166&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12482166')) {
      api.createRecord('12482166', component.options)
    } else {
      api.reload('12482166', component.options)
    }
    module.hot.accept("./add-pass.vue?vue&type=template&id=12482166", function () {
      api.rerender('12482166', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/add-pass.vue"
export default component.exports